import React, { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { PersonInformation } from '../../../components/molecules/PersonInformation';
import Btn from '../../../components/molecules/Btn';
import { Icons } from '../../../components/atoms/SVG';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';
import { Namespace } from '../../../translation/namespace';
import IUrl, { ISonURL } from '../../../types/IUrl';
import ILink from '../../../types/ILink';
import { ProfileImageSmall } from '../../../types/api/ImageType';

// type ContactPerson from structureService
export type ContactPerson = {
  id: string;
  profileName: string;
  profileLink: ILink;
  personInfoCardUrl: IUrl;
  profileImageUrl: ProfileImageSmall;

  phoneLink?: ISonURL;
  emailLink?: ISonURL;
  roleNames?: string[];
};

type ContactPersonProps = Omit<ContactPerson, 'id'>;

/** ContactPerson with information and actions */
export function ContactPerson({
  emailLink,
  personInfoCardUrl,
  phoneLink,
  profileImageUrl,
  profileLink,
  profileName,
  roleNames,
  children,
}: PropsWithChildren<ContactPersonProps>) {
  const { t } = useTranslation(Namespace.ContactPerson);
  return (
    <div className="contact-person">
      <PersonInformation
        profileImageUrl={profileImageUrl}
        infoCardUrl={personInfoCardUrl}
        phoneLink={phoneLink}
        profileName={profileName}
        profileLink={profileLink}
        roleNames={roleNames}
      />
      {children || (emailLink && emailLink.url)
        ? (
            <div className="contact-person__buttonblock">
              {children ||
                (emailLink && emailLink.url && (
                  <span className="contact-person__button-container">
                    <Btn
                      href={emailLink.url}
                      svgSpriteId={Icons.MAIL_ENVELOPE}
                      text={t('mailButton.text', { recipient: profileName })}
                      hiddenText
                      titleText={t('mailButton.text', { recipient: profileName })}
                      tooltipPlacement={TooltipPlacement.TOP}
                      cssClass="contact-person__button"
                    />
                  </span>
                ))}
            </div>
          )
        : null}
    </div>
  );
}
